<div
	ngDefaultControl
	[formGroup]="formGroup"
	[ngClass]="{
		'recurrency-wrapper':
			formGroup.controls.recurrency.value !== 'no-repeat' &&
			formGroup.controls.recurrency.value !== 'custom'
	}"
>
	<freud-select
		class="zk-flex-1"
		ngDefaultControl
		[label]="'APPOINTMENTS.RECURRENCY.LABEL' | translate"
		[options]="recurrencyOptions"
		name="recurrency"
		formControlName="recurrency"
		(onChange)="onChangeRecurrency($event)"
	></freud-select>
	<div class="zk-flex-1"
		*ngIf="
			formGroup.controls.recurrency.value !== 'no-repeat' &&
			formGroup.controls.recurrency.value !== 'custom'
		"
	>
		<div class="zk-gap-1 zk-flex zk-items-center">
			<span class="recurrency-label">{{
				'APPOINTMENTS.RECURRENCY_MAX_SESSIONS.LABEL' | translate
			}}</span>
			<div
				freud-tooltip
				[tooltipLabel]="
					'APPOINTMENTS.RECURRENCY_MAX_SESSIONS.TOOLTIP' | translate
				"
			>
				<span class="freud-icon freud-icon-info-circle"></span>
			</div>
		</div>
		<freud-input-number
			ngDefaultControl
			[min]="2"
			[max]="getMaxValueRecurrency()"
			[showButtons]="true"
			formControlName="recurrencyMaxSessions"
			[invalid]="formGroup.controls.recurrencyMaxSessions.invalid && formGroup.controls.recurrencyMaxSessions.touched"
		></freud-input-number>
	</div>
</div>
<div
	id="appointment-recurrency-alert"
	*ngIf="
		formGroup.controls.recurrency.value !== 'no-repeat' &&
		formGroup.controls.recurrency.value !== 'custom' &&
		formGroup.controls.dates.value[0].time &&
		formGroup.controls.dates.value[0].date 
	"
	class="appointment-recurrency-alert zk-flex zk-items-center zk-mt-2 zk-gap-2"
>
	<span class="freud-icon freud-icon-info-circle freud-icon-md"></span>
	<p freud-typography fontType="h5Regular1-5">
		{{
			'APPOINTMENTS.RECURRENCY.ALERT'
				| translate
					: {
							sessionNumber: formGroup.controls.recurrencyMaxSessions?.value ?? '',
							initialDate: getInitialDate(),
							frequency: getFrequencyText(),
							appointmentInitialHour: getAppointmentInitialHour()
					  }
		}}
	</p>
</div>
